<template>
  <div>
    <div v-if="!services">
      <div class="spinner-border text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div v-else>
      <div v-if="services && services.length > 0">
        <h1 style="text-align:center;">Usługi opiekuna</h1>
        <table class="table modal-table">
          <thead>
            <tr class="tr-table">
              <th scope="col">Cena</th>
              <th scope="col">ID usługi</th>
              <th scope="col">Kategoria</th>
              <th scope="col">Podkategoria</th>
              <th scope="col">Nazwa usługi</th>
              <th scope="col">Opis usługi</th>
              <th scope="col">Pierwszy próg</th>
              <th scope="col">Drugi próg</th>
              <th scope="col">Typ</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in services"
              v-bind:key="item.id"
              :class="{ firstVerification: item.service.need_verification }"
            >
              <td>{{ item.price }}</td>
              <td>{{ item.service.id }}</td>
              <td>
                {{
                  item.service.serviceCategoryEntity
                    ? item.service.serviceCategoryEntity.display_name
                    : "Brak"
                }}
              </td>
              <td>
                {{
                  item.service.sub_category
                    ? item.service.sub_category.display_name
                    : "Brak"
                }}
              </td>
              <td>{{ item.service.display_name }}</td>
              <td>{{ item.service.description || "Brak" }}</td>
              <td>{{ item.service.first_threshold }}</td>
              <td>{{ item.service.second_threshold }}</td>
              <td>{{ item.service.type }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="alert alert-danger notFoundListAlert">
        Ten opiekun nie ma aktualnie żadnych usług w swojej ofercie
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserServices",
  data() {
    return {
      toggleStationary: false,
    };
  },
  computed: {
    services() {
      return this.$store.getters.getUserServicesById;
    },
  },
  methods: {},
  created() {
    this.$store.dispatch("fetchUserServicesByUserId", this.$route.params.id);
  },
};
</script>

<style scoped>
.firstVerification {
  background: rgb(235, 119, 90);
}
</style>
